import { ref as f, resolveComponent as p, openBlock as c, createBlock as w, normalizeClass as _, withKeys as d, withModifiers as m, withCtx as h, createElementBlock as x, createCommentVNode as g, createTextVNode as k, renderSlot as B } from "vue";
import { unrefElement as u } from "./design-system.es125.js";
/* empty css                    */
import S from "./design-system.es128.js";
/* empty css                    */
/* empty css                    */
import y from "./design-system.es94.js";
/* empty css                    */
/* empty css                    */
const A = {
  name: "DsMenuContainer",
  components: {
    Stack: y
  },
  props: {
    isOpen: Boolean,
    fill: Boolean,
    scroll: Boolean,
    arrow: Boolean
  },
  setup() {
    const s = f(null);
    function l(n) {
      var r, t;
      const e = [...u(s).querySelectorAll(".ds-menu-item")];
      if (!(e.length <= 0)) {
        if (n.target.classList.contains("ds-menu-item")) {
          const i = e.findIndex((a) => a === n.target);
          i > 0 && ((r = e[i - 1]) == null || r.focus());
          return;
        }
        (t = e[e.length - 1]) == null || t.focus();
      }
    }
    function o(n) {
      var r, t;
      const e = [...u(s).querySelectorAll(".ds-menu-item")];
      if (!(e.length <= 0)) {
        if (n.target.classList.contains("ds-menu-item")) {
          const i = e.findIndex((a) => a === n.target);
          i < e.length - 1 && ((r = e[i + 1]) == null || r.focus());
          return;
        }
        (t = e[0]) == null || t.focus();
      }
    }
    return {
      el: s,
      handleUpArrow: l,
      handleDownArrow: o
    };
  }
}, C = {
  key: 0,
  "data-popper-arrow": "",
  class: "arrow"
};
function D(s, l, o, n, e, r) {
  const t = p("Stack");
  return c(), w(t, {
    ref: "el",
    class: _(["ds-menu-container", {
      "ds-menu-container--open": o.isOpen,
      "ds-menu-container--scroll": o.scroll,
      "ds-menu-container--fill": o.fill
    }]),
    tabindex: "0",
    onKeydown: [
      d(m(n.handleUpArrow, ["prevent"]), ["up"]),
      d(m(n.handleDownArrow, ["prevent"]), ["down"])
    ]
  }, {
    default: h(() => [
      o.arrow ? (c(), x("div", C)) : g("", !0),
      l[0] || (l[0] = k()),
      B(s.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 8, ["class", "onKeydown"]);
}
const U = /* @__PURE__ */ S(A, [["render", D], ["__scopeId", "data-v-3e369333"]]);
export {
  U as default
};
//# sourceMappingURL=design-system.es69.js.map
